<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4gDZJe/images/cover.jpg?1694257621886" alt="This image is the cover for the book Sierra Stories"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sierra Stories
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The author of <i>Gold Rush Stories</i> shares tales of the larger-than-life characters from the history of the legendary Sierra Nevada mountain range.</b></p><p>With its 14,000-foot granite mountains, crystalline lakes, conifer forests, and hidden valleys, the Sierra Nevada has long been the domain of dreams, attracting the heroic and the delusional, the best of humanity and the worst. Stories abound, and characters emerge so outlandish and outrageous that they must be real. Could the human imagination have invented someone like Eliza Gilbert? Born in Limerick, Ireland, in 1818, she transformed herself into Lola Montez, born in Seville, Spain, in 1823, and brought to the Gold Country the provocative “Spider Dance”—impersonating a young woman repelling a legion of angry spiders under her petticoats. Or Otto Esche, who in 1860 imported fifteen two-humped Bactrian camels from Asia to transport goods to the mines. Or the artist Albert Bierstadt, whose paintings Mark Twain characterized as having “more the atmosphere of Kingdom-Come than of California.” Or multimillionaire George Whittell Jr., who was frequently spotted driving around Lake Tahoe in a luxurious convertible with his pet lion in the front seat.</p> These, and scores more, spill out of the pages of this well-illustrated and lively tribute to the Sierra by a native son.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gary Noy, Malcolm Margolin
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Heyday, Berkeley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?08ee7066